import { CARDS } from "../../pendencias";

const NUMERO = { vermelho: "text-red-600", ambar: "text-amber-600" };

export default function CardsPendencias({ contagem, selecionado, onSelecionar }) {
	return (
		<div className="shrink-0 grid grid-cols-2 md:grid-cols-4 2xl:grid-cols-8 gap-3">
			{CARDS.map(({ chave, rotulo, tom }) => {
				const total = contagem[chave];
				const ativo = selecionado === chave;

				return (
					<button
						key={chave}
						type="button"
						disabled={total === 0}
						onClick={() => onSelecionar(chave)}
						title={ativo ? "Clique para mostrar todas as pendências" : `Mostrar só: ${rotulo}`}
						className={`text-left bg-white border rounded-md px-4 py-3 transition-colors disabled:cursor-default ${
							ativo
								? "border-customBlue-primary ring-2 ring-customBlue-primary/30"
								: "border-gray-300 enabled:hover:border-customBlue-primary/60"
						}`}
					>
						<div className={`text-2xl font-semibold leading-none ${total ? NUMERO[tom] : "text-gray-300"}`}>
							{total}
						</div>
						<div className={`text-xs mt-1.5 ${total ? "text-gray-600" : "text-gray-400"}`}>{rotulo}</div>
					</button>
				);
			})}
		</div>
	);
}
